import { Link } from "react-router-dom";
import { KCLogoIcon } from "@/components/brand/KCLogo";

const PRIMARY_LINKS = [
  { to: "/classes", label: "Group classes" },
  { to: "/private-lessons", label: "Private lessons" },
  { to: "/step-up", label: "Step Up" },
  { to: "/support", label: "Contact" },
  { to: "/enroll", label: "Create parent portal" },
  { to: "/login", label: "Log in" },
];

export function PublicNav() {
  return (
    <header className="border-b border-foreground/10 bg-landing-bg/95">
      <nav
        aria-label="Primary navigation"
        className="mx-auto flex min-h-20 w-full max-w-6xl flex-col items-start justify-between gap-3 px-6 py-4 sm:flex-row sm:items-center md:px-8"
      >
        <Link className="flex min-h-11 items-center gap-3" to="/" aria-label="Playce Academy home">
          <KCLogoIcon size={36} />
          <span className="font-display text-lg font-black uppercase italic leading-none tracking-tighter">
            <span className="text-foreground">playce</span>{" "}
            <span className="text-secondary">academy</span>
          </span>
        </Link>
        <div className="grid w-full grid-cols-2 items-center gap-x-4 text-sm font-bold sm:flex sm:w-auto sm:flex-wrap sm:justify-end sm:gap-x-5">
          {PRIMARY_LINKS.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className="inline-flex min-h-11 items-center justify-center text-center text-muted-foreground transition-colors hover:text-foreground sm:justify-start"
            >
              {item.label}
            </Link>
          ))}
        </div>
      </nav>
    </header>
  );
}

export function PublicFooter() {
  return (
    <footer className="border-t border-foreground/10 px-6 py-10">
      <div className="mx-auto flex max-w-6xl flex-col gap-5 text-sm text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
        <p>Playce Academy · Where play has a purpose.</p>
        <nav aria-label="Footer navigation" className="flex flex-wrap gap-x-5 gap-y-3">
          <Link to="/classes" className="inline-flex min-h-11 items-center hover:text-foreground">Group classes</Link>
          <Link to="/private-lessons" className="inline-flex min-h-11 items-center hover:text-foreground">Private lessons</Link>
          <Link to="/step-up" className="inline-flex min-h-11 items-center hover:text-foreground">Step Up</Link>
          <Link to="/support" className="inline-flex min-h-11 items-center hover:text-foreground">Contact</Link>
          <Link to="/enroll" className="inline-flex min-h-11 items-center hover:text-foreground">Create parent portal</Link>
          <Link to="/login" className="inline-flex min-h-11 items-center hover:text-foreground">Log in</Link>
          <Link to="/privacy" className="inline-flex min-h-11 items-center hover:text-foreground">Privacy</Link>
          <Link to="/terms" className="inline-flex min-h-11 items-center hover:text-foreground">Terms</Link>
        </nav>
      </div>
    </footer>
  );
}
